//
// create slice
// as centeralize between actions and reducers
//
// serviceActions module contains reducers and actions that
// created by createAsyncThunk from redux-toolkit
//
// for standard actions, that require other business logic
// can be put inside extraActions module
//
// export default will be reducers it self that processed by store
// other exports will contains actions that's dispatched from ReactComponent
//

import { createSlice } from '@reduxjs/toolkit';
import {
  qboFetchSearchItemsAsync,
  qboFetchSearchItemsExtraReducers,
} from './serviceActions/fetchQboSearchItemsAsync';

const initialState = {
  QboSearchItems: {
    showPagination: false,
    companyName: null,
    backupStatus: null,
    lastBackupAt: null,
    lastCompletedBackupAt: null,
    value: [],
    nextLink: null,
    prevLink: null,
  },
  fetchingQboSearchItems: false,
  error: null,
};

const qboSearchItemsSlice = createSlice({
  name: 'QboSearchItems',
  initialState,
  reducers: {
    resetState() {
      return initialState;
    },
  },
  extraReducers: {
    ...qboFetchSearchItemsExtraReducers,
  },
});

export const { resetState } = qboSearchItemsSlice.actions;
export { qboFetchSearchItemsAsync };
export default qboSearchItemsSlice.reducer;
